import { unknownToString } from 'libs/end-to-end/src/generic';

const formatterCache: Record<string, Intl.NumberFormat> = {};

const getFormatterKey = (params: {
  currency: string;
  roundToWholeValue: boolean;
}): string => {
  return `${params.currency}-${unknownToString(params.roundToWholeValue)}`;
};

export const formatPriceAmountToString = (params: {
  amount: number;
  currency: string;
  roundToWholeValue?: boolean;
}): string | null => {
  const roundToWholeValue = params.roundToWholeValue ?? true;
  try {
    // make formatter not return cents
    let formatter =
      formatterCache[
        getFormatterKey({ currency: params.currency, roundToWholeValue })
      ];

    if (!formatter) {
      formatter = new Intl.NumberFormat('default', {
        style: 'currency',
        notation: 'compact',
        currency: params.currency.toUpperCase(),
        ...(roundToWholeValue && {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }),
      });
      formatterCache[
        getFormatterKey({ currency: params.currency, roundToWholeValue })
      ] = formatter;
    }

    const minimumFractionDigits =
      formatter.resolvedOptions().minimumFractionDigits;

    if (minimumFractionDigits === undefined) {
      return null;
    }

    const subunitAmount = params.amount / Math.pow(10, minimumFractionDigits);
    return formatter.format(subunitAmount);
  } catch {
    return null;
  }
};
